export default __webpack_public_path__ + "static/media/neraca1.c43d0efb.png";